import type { TFunction } from "i18next"
import { toast } from "sonner"
import type { NavigateFunction } from "react-router-dom"

const PARTIAL_SEED_TOAST_MS = 14_000

/** Sonner toast when the workspace row exists but visa checklist seeding reported an error. */
export function toastPartialWorkspaceSeed(
  t: TFunction,
  navigate: NavigateFunction,
  workspaceId: string,
  description?: string
): void {
  toast.error(t("workspace.error.message"), {
    duration: PARTIAL_SEED_TOAST_MS,
    ...(description ? { description } : {}),
    action: {
      label: t("workspace.error.viewAnyway"),
      onClick: () => {
        void navigate(`/workspaces/${workspaceId}/overview`)
      },
    },
    cancel: {
      label: t("workspace.error.retry"),
      onClick: () => {
        void navigate(`/workspaces/${workspaceId}/tasks`)
      },
    },
  })
}
